import { ROLE_PRIORITIES } from './permissions';

export const hasPermissionByPriority = (roles: any[], minPriority: number): boolean => {
  return roles.some((role) => {
    const rolePriority = ROLE_PRIORITIES[role.id] || 0;
    return rolePriority >= minPriority;
  });
};